import { render } from "./AudioUpload.vue?vue&type=template&id=0172f8ea&scoped=true&ts=true"
import script from "./AudioUpload.vue?vue&type=script&lang=ts"
export * from "./AudioUpload.vue?vue&type=script&lang=ts"

import "./AudioUpload.vue?vue&type=style&index=0&id=0172f8ea&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0172f8ea"]])

export default __exports__